import { cn } from "utils/src/cn";
import type { SideMenuNavTier } from "./sideMenuNavConfig";

export interface SideMenuNavPresentationInput {
  tier: SideMenuNavTier;
  isCurrent: boolean;
  isOpen: boolean;
}

/**
 * Figma Side Menu v5 `45420:26723` / 组件集 `87715:35675` — 左列 active/hover，右列 default。
 *
 * Primary（Brief/Invest/Plan/Desk）:
 * - default: icon quaternary + label primary (`body_medium_m`)
 * - active/hover: icon brand + label brand + overlay5 pill（`45420:27112` Plan 选中态）
 *
 * Secondary（News/Discover/Portfolio/Missions）:
 * - default: icon quaternary + label secondary
 * - active/hover: icon + label brand
 */
export function getSideMenuNavItemClasses({
  tier,
  isCurrent,
  isOpen,
}: SideMenuNavPresentationInput) {
  const isPrimary = tier === "primary";

  const link = cn(
    "group flex w-full items-center rounded-2 transition-colors",
    isPrimary ? "gap-3 p-2" : "gap-3 px-2 py-1",
    {
      "bg-background_brand_overlay5": isPrimary && isCurrent && isOpen,
      "hover:bg-background_brand_overlay5": isPrimary && isOpen,
      "w-8 flex-col justify-center gap-1 p-2": !isOpen,
    },
  );

  const icon = cn(
    "shrink-0 transition-colors",
    isPrimary
      ? isCurrent
        ? "text-content_brand_primary"
        : "text-content_quaternary group-hover:text-content_brand_primary"
      : isCurrent
        ? "text-content_brand_primary"
        : "text-content_quaternary group-hover:text-content_brand_primary",
  );

  const label = cn(
    "block w-fit shrink-0 transition-colors",
    isPrimary ? "body_medium_m" : "body_m",
    isPrimary
      ? isCurrent
        ? "text-content_brand_primary"
        : "text-content_primary group-hover:text-content_brand_primary"
      : isCurrent
        ? "text-content_brand_primary"
        : "text-content_secondary group-hover:text-content_brand_primary",
    {
      hidden: !isOpen,
    },
  );

  const iconWrap = cn(
    "relative flex shrink-0 items-center justify-center",
    isPrimary ? "size-5" : "size-4",
  );

  return { link, icon, label, iconWrap, iconSize: isPrimary ? 20 : 16 };
}
